import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-provider-payplans',
  templateUrl: './provider-payplans.component.html',
  styleUrl: './provider-payplans.component.css'
})

export class ProviderPayplansComponent {

  loading: boolean = false;
  payplanModal: boolean = false

  payplanForm: FormGroup

  providers: any = [];
  providerPlans: any = [];

  companies: any = [];

  planTypes: any = [
    { value: 'base', label: 'Base Pay' },
    { value: 'override', label: 'Override' }
  ];

  constructor(
    private data: DataserviceService
  ) {

    this.payplanForm = new FormGroup({
      'id': new FormControl(null),
      'name': new FormControl(null, [Validators.required]),
      'provider_id': new FormControl(null, [Validators.required]),
      'company_id': new FormControl(null, [Validators.required]),
      'type': new FormControl('base', [Validators.required])
    })

  }

  ngOnInit() {
    this.getPlans();
    this.getProviders();
    this.getCompanies();
  }

  getPlans() {
    this.loading = true;
    this.data.get('provider-payplans')
      .subscribe({
        next: (res: any) => {
          console.log(res)
          this.providerPlans = res;
          this.loading = false;
        },
        error: (err: any) => {

        }
      })
  }

  getCompanies() {
    this.data.getData(`company`)
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
        }
      })
  }
 
  getProviders() {
    this.data.getData('providers')
      .subscribe({
        next: (res: any) => {
          console.log(res)
          this.providers = res?.data;
        }
      })
  }


  addPayplan() {
    if(this.payplanForm?.valid) {
      this.loading = true;
    
      if(this.payplanForm?.get('id')?.value) {

        this.data.postData(this.payplanForm?.value, `provider-payplans/edit`)
          .subscribe({
            next: (res: any) => {
              this.loading = false;
              this.providerPlans = res;
              this.payplanModal = false;
              this.payplanForm.reset();
            },
            error: (err: any) => {
              this.loading = false;
              alert('Failed to edit pay plan!')
            }
          })
        
      }else {

        this.data.postData(this.payplanForm?.value, `provider-payplans/add`)
          .subscribe({
            next: (res: any) => {
              this.loading = false;
              this.providerPlans = res;
              this.payplanModal = false;
              this.payplanForm.reset();
            },
            error: (err: any) => {
              this.loading = false;
              alert('Failed to add pay plan!')
            }
          })

      }
    }else {
      alert('Please fill out all fields')
    }
  }

  statusPlan(p: any) {
    this.loading = true;
    this.data.postData(p, `provider-payplans/status`)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.providerPlans = res;
        }
      })
  }

  openEdit(p: any) {
    this.payplanForm?.patchValue({
      id: p.id,
      name: p.name,
      provider_id: p.provider_id,
      company_id: p.company_id,
      type: p.type
    });

    this.payplanModal = true;
  }

  closePlan() {
    this.payplanForm.reset();
    this.payplanModal = false
  }
}
